import React from 'react';
import {Provider} from 'react-redux';
import {Footer} from '@piggybank/core';
import SessionTimeout from 'app/SessionTimeout';

import {Routing} from '../routes';

import store from './store';
import AppContext from './AppContext';

function IntlControllor() {
  const sessionContext = {
    contextId: 'NA',
  };
  return (
    <>
      <AppContext value={sessionContext}>
        <Routing />
        <Footer>
          HSBC Group | © HSBC Bank Australia Limited ABN 48 006 434 162 AFSL/Australian Credit
          Licence 232595 All rights reserved.
        </Footer>
        <SessionTimeout />
      </AppContext>
    </>
  );
}

export default function Controller() {
  return (
    <React.Fragment>
      <Provider store={store}>
        <IntlControllor />
      </Provider>
    </React.Fragment>
  );
}
